import React from "react"

import { Skeleton } from "@coval/ui"

const MetricCardSkeleton: React.FC = () => (
  <div className="p-6 space-y-3">
    <Skeleton className="h-4 w-3/4" />
    <Skeleton className="h-8 w-1/2" />
    <Skeleton className="h-3 w-2/3" />
  </div>
)

export const MetricCardSkeletonGrid: React.FC<{
  count?: number
  useSingleColumn?: boolean
}> = ({ count = 4, useSingleColumn = false }) => (
  <div
    className={`grid border-t border-coval-border ${useSingleColumn ? "grid-cols-1" : "grid-cols-2"}`}
  >
    {Array.from({ length: count }).map((_, i) => (
      <div
        key={i}
        className={`border-b border-coval-border ${!useSingleColumn && i % 2 === 0 ? "border-r" : ""}`}
      >
        <MetricCardSkeleton />
      </div>
    ))}
  </div>
)
